import { FC, useEffect } from 'react';
import { Grid } from '@mui/system';
import { isEmpty } from 'lodash';
import { globalAction } from 'common/actions';
import { FUNDS_ADD_INVESTMENTS, FUNDS_INVESTMENTS_TITLE, FUNDS_NO_INVESTMENTS } from 'common/constants/funds';
import { useStore } from 'common/store';
import { UseStoreValues } from 'common/types/store';
import { CustomCompactContainer, CustomContainer, MessageBox, SectionHeading } from 'components';
import { GridSkeleton } from 'components/Grid';
import { SCHEDULE_OF_INVESTMENTS_CONTAINER_CLASSNAME } from 'pages/Funds/common/constants/scheduleOfInvestments';
import { PdfExportTargets } from 'pages/Valuations/util/constants';
import { useGetFundInvestments } from 'services/hooks/funds';
import { getNumberValue } from 'utilities';
import CompanyInvestments from './components/CompanyInvestments/CompanyInvestments';
import { ScheduleOfInvestmentsProps } from './types';

const ScheduleOfInvestments: FC<ScheduleOfInvestmentsProps> = props => {
  const { fund, measurementDate } = props;

  const [, dispatch] = useStore() as unknown as UseStoreValues;

  const { data: fundInvestments, isFetching, isLoading } = useGetFundInvestments({ fund, measurementDate });

  // Show Loading Progress
  useEffect(() => {
    dispatch?.(globalAction.showLoadingProgress(isLoading));
  }, [dispatch, isLoading]);

  // If there are no investments made on this Fund and the data is still loading
  if (isEmpty(fundInvestments?.companies)) {
    if (isLoading) {
      return <GridSkeleton maxColumns={10} maxRows={4} />;
    }

    // No Investments made on this Fund
    return <MessageBox fullWidth={false} tagline={FUNDS_ADD_INVESTMENTS} title={FUNDS_NO_INVESTMENTS} />;
  }

  return (
    <CustomCompactContainer className={SCHEDULE_OF_INVESTMENTS_CONTAINER_CLASSNAME}>
      <Grid size={{ xs: 12 }}>
        {!isLoading && <SectionHeading leftAligned title={FUNDS_INVESTMENTS_TITLE} />}

        <CustomContainer data-ref={PdfExportTargets.SCHEDULE_OF_INVESTMENTS.id}>
          {fundInvestments?.companies?.map(company => (
            <CompanyInvestments
              company={company}
              isLoading={isLoading}
              isFetching={isFetching}
              key={getNumberValue(company?.company_id)}
              measurementDate={measurementDate}
            />
          ))}
        </CustomContainer>
      </Grid>
    </CustomCompactContainer>
  );
};

export default ScheduleOfInvestments;
